/**
 * Only runs the provided callback function once the timer reaches 0.
 * If the `debounce` function gets called before the timer has reached 0 it takes another `timeout`
 * milliseconds before the callback gets executed.
 * The callback will get executed one time.
 *
 * @param {function} func - The function to debounce.
 * @param {number} timeout - Time in milliseconds.
 * @returns
 */
function debounce(func, timeout = 500) {
  let timer;

  return (...args) => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export default debounce;
